import { createContext, useState } from "react";

export const DataContext = createContext();

const DataProvider = ({ children }) => {
  const [collectedData, setCollectedData] = useState({});
  const [enterManually, setEnterManually] = useState(false);
  const collectData = (data) => {
    setCollectedData((prevData) => ({ ...prevData, ...data }));
  };
  const EnterManually = (data) => {
    setEnterManually(data);
  };
  return (
    <DataContext.Provider
      value={{
        collectedData,
        collectData,
        enterManually,
        EnterManually,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
export default DataProvider;
